import React, { Component } from "react";
import "./ViewSignatureSamplePopup.scss";
import rightSignatureSample from "../../../assets/right-signature-sample.jpg";
import wrongSignatureOne from "../../../assets/wrong-signature-one.jpg";
import wrongSignatureTwo from "../../../assets/wrong-signature-two-new.jpg";
import wrongSignatureThree from "../../../assets/wrong-signature-three.jpg";

import BottomPanel from "../../BottomPanel/BottomPanel";
export interface IViewSignatureSampleMobileViewProps {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
}
const ViewSignatureSamplePopupMobileView = (
  props: IViewSignatureSampleMobileViewProps
) => {
  const getMobileUIPopup = () => {
    return (
      <div className="mobile-view">
        <h2 className="mobile-view-text" id="sample-popup-mobile-title">Guide for Signature Upload</h2>
        <div className="grid">
          <div className="box-1">
            <img
              src={rightSignatureSample}
              alt="Valid Signature"
              height={100}
              width={140}
            />
            <p className="success">Use a clear background.</p>
          </div>

          <div className="box-1">
            <img
              src={wrongSignatureOne}
              alt="Ruled Background"
              height={100}
              width={140}
            />
            <p className="error"> Don't use a ruled background.</p>
          </div>

          <div className="box-1">
            <img
              src={wrongSignatureTwo}
              alt="Ruled Background"
              height={100}
              width={140}
            />
            <p className="error"> Don't use a light stroke.</p>
          </div>

          <div className="box-1">
            <img
              src={wrongSignatureThree}
              alt="Thick Stroke"
              height={100}
              width={140}
            />
            <p className="error"> Don't use a thick stroke.</p>
          </div>
        </div>
      </div>
    );
  };
  return (
    <BottomPanel customComponent={getMobileUIPopup} setShowSection={props?.setShowPopup}/>
  );
};
export default ViewSignatureSamplePopupMobileView;
